import { Model_LogVariableEnvironnementUser } from 'src/app/app.models';
import { QueryParams_LogVariableEnvironnementUser } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

export abstract class LogEnvVarUserOfflineDao {
    abstract doSyncLogsEnvVarUserAction(_logEnvVars: Model_LogVariableEnvironnementUser[]): Promise<void>;
    abstract doClearLogsEnvVarUserAction(): Promise<void>;
    abstract doGetLogsEnvVarUserAction(_queryParams?: any): Promise<Model_LogVariableEnvironnementUser[]>;
    abstract doInsertLogsEnvVarUserAction(_logEnvVars: Model_LogVariableEnvironnementUser[]): Promise<void>;
    abstract doSaveLogEnvVarUserAction(_logEnvVar: Model_LogVariableEnvironnementUser): Promise<Model_LogVariableEnvironnementUser>;
    abstract doGetLogEnvVarAction(_guid: string): Promise<Model_LogVariableEnvironnementUser>;
    abstract doDeleteLogEnvVarUserAction(_guid: string): Promise<void>;
}